import React from 'react'
import { Wheel } from 'react-custom-roulette'
import Logo from '../../assets/images/logo.png'
import { useGetRouletteOptionsQuery } from '../../store/api/rouletteApi'
import { useTranslation } from 'react-i18next'
import { getStorageKey } from '../../utils/appType'

type Props = {
  setOpen: (isOpen: boolean) => void
}

const ViewRouletteWheel: React.FC<Props> = ({ setOpen }) => {
  const { data = [] } = useGetRouletteOptionsQuery()
  const { t } = useTranslation()
  const generalInfo = JSON.parse(
    localStorage.getItem(getStorageKey('info')) || '{}',
  )

  if (data.length === 0) {
    return null
  }

  return (
    <div className='roulette-overlay' onClick={() => setOpen(false)}>
      <div className='roulette-container'>
        <div className='wheel-wrapper' style={{ position: 'relative' }}>
          <Wheel
            mustStartSpinning={false}
            prizeNumber={0}
            data={data}
            outerBorderWidth={5}
            innerBorderWidth={15}
            radiusLineWidth={2}
            radiusLineColor=''
            outerBorderColor='white'
            fontSize={16}
            perpendicularText={false}
            textDistance={60}
          />
          <button
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: 'var(--color-primary)',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              cursor: 'default',
              zIndex: 10,
              fontSize: '18px',
            }}
          >
            <img
              src={Logo}
              alt='logo'
              style={{ width: '50px', height: '50px', marginTop: '5px' }}
            />
          </button>
        </div>
      </div>
      {generalInfo.rouletteRules && (
        <div className='roulette-rules'>
          <div className='roulette-rules-content'>
            <div className='roulette-rules-title'>{t('DETAILS')}</div>
            <p>{generalInfo.rouletteRules}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ViewRouletteWheel
